import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { wizardScreenPaths } from '../routes/routes_const';
import { getWebOrderInfoAPI } from '../../../utils/api';
import { trackEvent } from '../../../utils/analytics/analytics';

function Navigation({
  setupInitialScreen, currentScreen, initialScreen, updateCurrentScreen
}) {
  const history = useNavigate();
  const location = useLocation();

  const windowBeforeUnloadHandler = () => {
    getWebOrderInfoAPI();
  };

  useEffect(() => {
    window.addEventListener('beforeunload', windowBeforeUnloadHandler);
    setupInitialScreen();
    return () => {
      window.removeEventListener('beforeunload', windowBeforeUnloadHandler);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (!initialScreen || typeof initialScreen === 'undefined') return;
    if (initialScreen.name) {
      const queryParams = queryString.stringify(queryString.parse(location.search));
      history(`${ initialScreen.path }${ queryParams ? `?${ queryParams }` : '' }`, { replace: true });
    }
  }, [initialScreen]);

  useEffect(() => {
    if (!currentScreen || typeof currentScreen === 'undefined') return;
    if (currentScreen.path !== location.pathname && initialScreen.name) {
      const queryParams = queryString.stringify(queryString.parse(location.search));
      history(`${ currentScreen.path }${ queryParams ? `?${ queryParams }` : '' }`, { replace: true });
    }
  }, [currentScreen]);

  useEffect(() => {
    if (!currentScreen || typeof currentScreen === 'undefined') return;
    trackEvent('inner page view', {
      url: window.location.href
    });
    if (currentScreen.path !== location.pathname) {
      const screenName = Object.keys(wizardScreenPaths)
        .find((key) => wizardScreenPaths[key] === location.pathname);
      updateCurrentScreen(screenName);
    }
  }, [location]);
}

Navigation.propTypes = {
  setupInitialScreen: PropTypes.func.isRequired,
  currentScreen: PropTypes.object,
  initialScreen: PropTypes.object,
  updateCurrentScreen: PropTypes.func.isRequired
};

Navigation.defaultProps = {
  currentScreen:null,
  initialScreen: null
};

export default Navigation;
